export const getPageName = (pathname: string): string => {
  if (pathname.match(/\/watch\/[a-zA-Z0-9]+/)) {
    return 'video'
  } else if (pathname.match(/\/[a-zA-Z0-9]+/)) {
    return 'profile'
  } else {
    return 'home'
  }
}
